import { useEffect, useState } from 'react';
import { api } from '../api/odjemalec';

/** Slika vozila iz aplikacije: s strežnika z žetonom (img ga ne pošlje), zato kot blob; mala različica privzeto. */
export function useSlikaVozila(voziloId: number, slikaId: number | undefined, mala = true): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!slikaId) {
      return;
    }
    let naslov: string | null = null;
    const prekini = new AbortController();
    void api
      .GET('/api/vozila/{id}/slike/{slikaId}', {
        signal: prekini.signal,
        params: { path: { id: voziloId, slikaId }, query: { mala } },
        parseAs: 'blob',
      })
      .then(({ data, response }) => {
        if (response.ok && data instanceof Blob) {
          naslov = URL.createObjectURL(data);
          setUrl(naslov);
        }
      })
      .catch(() => undefined);
    return () => {
      prekini.abort();
      if (naslov) {
        URL.revokeObjectURL(naslov);
      }
      setUrl(null);
    };
  }, [voziloId, slikaId, mala]);
  return url;
}
